import ModalMainWrapper from './ModalMainWrapper'
import { ModalStore } from '../../state/ModalStore'

function OlcTransitionModal({ olmUrl, onChangeAnswers }) {
    const skimModal = ModalStore((state) => state.skim)

    const handleClick = () => {
        skimModal()
    }

    const handleChangeAnswers = () => {
        skimModal()
        onChangeAnswers?.()
    }

    return (
        <ModalMainWrapper>
            <div className="inline-block w-[min(96vw,860px)] rounded-[24px] bg-[#FFF6EE] align-middle shadow-[0_18px_40px_rgba(0,0,0,0.22),0_2px_10px_rgba(0,0,0,0.08)] transition-all transform">
                <div className="relative overflow-hidden bg-[radial-gradient(circle_at_88%_76%,rgba(250,179,49,0.10),transparent_32%),#fffaf4] px-3 py-3 sm:px-4 sm:py-4">
                    <div className="absolute right-0 top-0 h-[150px] w-[150px] rounded-full bg-[radial-gradient(circle,rgba(250,179,49,0.10)_0%,transparent_70%)]" />
                    <div className="relative rounded-[22px] bg-transparent px-4 py-5 sm:px-6 sm:py-6">
                        <div className="mx-auto flex max-w-3xl flex-col items-center text-center">
                            <img
                                src="/assets/modals/olc-logo.png"
                                alt="Open Letter Connect"
                                className="mb-4 h-auto w-[220px] sm:w-[250px]"
                            />

                            <div className="mb-4 inline-flex items-center gap-1.5 rounded-full bg-[#fff0e9] px-4 py-2 text-[12px] font-bold text-[#c35f37] sm:text-[13px]">
                                <span aria-hidden="true">✓</span>
                                <span>No minimum order required</span>
                            </div>

                            <h2 className="text-[24px] font-extrabold leading-[1.04] tracking-[-1.2px] text-[#20252d] sm:text-[34px]">
                                Start mailing on{' '}
                                <span className="text-[#ed5c2f]">
                                    your terms.
                                </span>
                            </h2>

                            <p className="mt-3 max-w-2xl text-[13px] leading-[1.55] text-[#7d828b] sm:text-[15px]">
                                Open Letter Connect is our self-service platform
                                built to help you create and send direct mail
                                whenever you&apos;re ready, no call or minimum
                                spend required.
                            </p>
                        </div>

                        <div className="mx-auto mt-6 max-w-3xl">
                            <a
                                href={olmUrl}
                                target="_blank"
                                rel="noreferrer"
                                onClick={handleClick}
                                className="block w-full rounded-full bg-[linear-gradient(90deg,#ed5c2f,#eb8148_58%,#f0ad60)] px-5 py-3 text-center text-white shadow-[0_12px_28px_rgba(237,92,47,0.22)] transition hover:-translate-y-0.5 hover:shadow-[0_16px_34px_rgba(237,92,47,0.28)]">
                                <strong className="block text-[16px] font-extrabold sm:text-[18px]">
                                    Sign up or log in →
                                </strong>
                            </a>

                            <button
                                type="button"
                                onClick={handleChangeAnswers}
                                className="mx-auto mt-3 block px-3 py-1.5 text-[12px] text-[#6f7379] transition hover:text-[#ed5c2f] sm:text-[13px]">
                                ← Change my answers
                            </button>
                        </div>
                    </div>
                </div>
            </div>
        </ModalMainWrapper>
    )
}

export default OlcTransitionModal
